import { useEffect, useState } from 'react'
import Chip from '../../ds/Chip.jsx'
import { watchForms, watchFormStats } from '../../lib/formsData.js'
import { formAnalytics } from '../../lib/formsView.js'

// One row's 30-day stats, watched lazily per form.
function FormRow({ form, onOpen }) {
  const [stats, setStats] = useState([])
  useEffect(() => watchFormStats(form.id, setStats), [form.id])
  const a = formAnalytics(stats, 30)
  const pct = a.conversion == null ? '—' : `${Math.round(a.conversion * 100)}%`
  const cell = { padding: '10px 12px', fontSize: 13, color: 'var(--color-white)' }
  const num = { ...cell, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }
  return (
    <tr onClick={() => onOpen(form.id)} style={{ cursor: 'pointer', borderTop: '1px solid var(--color-divider-dark)' }}>
      <td style={cell}>{form.name || form.slug}</td>
      <td style={cell}>
        <Chip variant="outline" color={form.status === 'published' ? 'var(--color-gold)' : 'var(--color-muted)'} dot>
          {form.status || 'draft'}
        </Chip>
      </td>
      <td style={num}>{a.views}</td>
      <td style={num}>{a.submissions}</td>
      <td style={num}>{pct}</td>
      <td style={num}>{a.spam}</td>
    </tr>
  )
}

export default function FormsIndex({ onOpenForm }) {
  const [forms, setForms] = useState([])
  useEffect(() => watchForms(setForms), [])
  const th = { padding: '8px 12px', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--color-muted)', textAlign: 'left' }
  const thr = { ...th, textAlign: 'right' }
  return (
    <div>
      <div className="eyebrow" style={{ marginBottom: 12 }}><span className="tag-label" style={{ color: 'var(--color-gold)' }}>Workspace</span></div>
      <h1 className="font-display" style={{ fontSize: 42, margin: '0 0 4px', letterSpacing: '.01em', lineHeight: 0.95, textTransform: 'uppercase', color: 'var(--color-white)' }}>Forms</h1>
      <p style={{ margin: '0 0 22px', fontSize: 13, color: 'var(--color-muted)' }}>Submissions, quarantine review, and analytics for your published forms. Last 30 days.</p>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={th}>Form</th><th style={th}>Status</th>
              <th style={thr}>Unique views</th><th style={thr}>Submissions</th><th style={thr}>Conversion</th><th style={thr}>Spam</th>
            </tr>
          </thead>
          <tbody>
            {forms.map((f) => <FormRow key={f.id} form={f} onOpen={onOpenForm} />)}
          </tbody>
        </table>
        {forms.length === 0 && <div style={{ fontSize: 13, color: 'var(--color-muted)', padding: '16px 12px' }}>No forms yet.</div>}
      </div>
    </div>
  )
}
